<template>
    <!--begin::Content wrapper-->
    <div dir="rtl" class="modal fade forgetpassword-modal qbank-section" id="changename-modal" tabindex="-1"
        role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">
                        تغيير نوع الاختبار
                    </h5>
                    <button type="button" class="btn btn-light" data-bs-dismiss="modal">
                        <i class="fa fa-close"></i> إغلاق
                    </button>
                </div>
                <div class="modal-body">

                    <h4 class="mb-2 text-center support-text">
                        <div class="mb-2"> تغيير إسم الاختبار</div>
                        <br />
                    </h4>

                    <form @submit.prevent="handleSubmit" class="form-horizontal">
                        <div class="row" dir="rtl">
                            <input type="hidden" id="qbankId" />
                            <div class="col-md-12">
                                <label class="form-label fw-bold mb-3"> أدخل أدناه إسم الاختبار </label>
                                <div class="btn-group w-100" role="group" aria-label="Quiz Type">
                                    <input type="text" class="form-control" name="qName" id="qName" v-model="qName">
                                </div>
                            </div>

                        </div>

                        <hr />

                        <div class="text-end d-flex justify-content-between align-items-center mt-4">
                            <button type="button" class="btn btn-outline-secondary rounded-pill px-4"
                                data-bs-dismiss="modal">
                                <i class="fa fa-arrow-right me-2"></i> عودة
                            </button>
                            <button class="btn btn-success rounded-pill px-4 d-flex align-items-center" type="submit"
                                :disabled="isLoading">
                                <i class="fa fa-check me-2"></i> تعديل
                                <span v-if="isLoading" class="spinner-border spinner-border-sm ms-2" role="status"
                                    aria-hidden="true"></span>
                            </button>
                        </div>
                    </form>

                </div>
            </div>
        </div>
    </div>
    <!--end::Content wrapper-->
</template>

<script>
import Swal from "sweetalert2";
import { apiUrl } from "@/utils/api"; // Adjust the import path according to your project structure

export default {
    name: "ChangeName",
    data() {
        return {
            token: localStorage.getItem("access_token"),
            code: "",
            isLoading: false,
            qName: "", // تأكد إن عندك qtype لربط v-model
        };
    },
    methods: {
        handleSubmit() {
            this.changeType();
        },
        async changeType() {
            let questionBank = document.getElementById("qbankId").value;
            try {
                const result = await Swal.fire({
                    title: "هل أنت متأكد من العملية؟",
                    text: " ",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3ddc97",
                    cancelButtonColor: "#f46a6a",
                    cancelButtonText: "لا",
                    confirmButtonText: "نعم",
                });

                if (result.isConfirmed) {
                    this.isLoading = true;
                    let questionBank = document.getElementById("qbankId").value;
                    const response = await fetch(`${apiUrl}/qbanks/${questionBank}`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${this.token}`,
                        },
                        body: JSON.stringify({ name: this.qName, _method: 'PUT' }),
                    });

                    if (!response.ok) {
                        const errorResponse = await response.json();
                        throw errorResponse;
                    }

                    Swal.fire({
                        icon: "success",
                        title: "تم التحديث بنجاح",
                        text: "",
                    }).then((result) => {
                        if (result.isConfirmed) {
                            location.reload();
                        }
                    });
                    this.isLoading = false;
                }
            } catch (error) {
                console.error(error);
                this.isLoading = false;
                Swal.fire("خطأ", "حدث خطأ ما. الرجاء المحاولة مرة أخرى.", "error");
            }
        },
        changeMode(questionBank) {
            const input = document.getElementById("qbankId");
            if (input) {
                input.value = questionBank.id;
            }
        }
    }
};
</script>

<style scoped>
.btn-charge {
    padding: 10px 50px;
    font-weight: 600;
    background: rgb(0, 196, 68);
    border: none;
}

.btn-success {
    background-color: #00c444;
    border-color: #00c444;
    transition: 0.3s;
}

.btn-success:hover {
    background-color: #00a03b;
    border-color: #009334;
}

.btn-outline-secondary {
    border: 2px solid #ced4da;
    color: #495057;
    background-color: white;
    transition: 0.3s;
}

.btn-outline-secondary:hover {
    background-color: #f8f9fa;
    color: #212529;
    border-color: #adb5bd;
}

.btn-check:checked+.btn {
    background-color: #00c444;
    color: #fff;
    border-color: #00c444;
}

.btn-outline-primary {
    padding: 10px;
    font-weight: 500;
    transition: all 0.3s ease-in-out;
}
</style>
